var _linearGradient, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 512,
    y1: 256,
    y2: 256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdbed",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdbed"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m20.337 133.512c-23.967 39.398-26.493 107.613-8.937 150.256 15.377 37.351 45.966 72.409 86.12 76.801 14.766 1.615 29.858-1.024 44.472 1.638 50.257 9.152 68.952 71.09 108.01 104.014 27.182 22.913 64.898 31.021 100.174 26.607s68.302-20.363 97.376-40.824c22.957-16.157 44.436-36.022 55.764-61.707 23.744-53.839-4.19-118.501-47.587-158.239-13.516-12.377-28.581-23.294-39.875-37.727s-18.48-33.695-13.099-51.214c4.293-13.977 15.849-24.812 20.227-38.763 5.958-18.984-3.035-40.281-17.802-53.616s-34.308-20.039-53.666-24.64c-81.103-19.28-258.823-11.524-331.177 107.414z",
    fill: "url(#SVGID_1_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m455.47 452.847h-398.94c-8.284 0-15-6.716-15-15v-314.266c0-8.284 6.716-15 15-15h398.94c8.284 0 15 6.716 15 15v314.266c0 8.285-6.715 15-15 15z",
    fill: "#2626bc",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.47 428.133h-398.94c-8.284 0-15-6.716-15-15v-314.266c0-8.284 6.716-15 15-15h398.94c8.284 0 15 6.716 15 15v314.266c0 8.285-6.715 15-15 15z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m470.47 153.18v-54.313c0-8.284-6.716-15-15-15h-398.94c-8.284 0-15 6.716-15 15v54.313z",
    fill: "#ff7eb8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.47 433.133h-398.94c-11.028 0-20-8.972-20-20v-314.266c0-11.028 8.972-20 20-20h398.94c11.028 0 20 8.972 20 20v314.266c0 11.028-8.972 20-20 20zm-398.94-344.266c-5.514 0-10 4.486-10 10v314.266c0 5.514 4.486 10 10 10h398.94c5.514 0 10-4.486 10-10v-314.266c0-5.514-4.486-10-10-10z",
    fill: "#2626bc"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 85.623,
    cy: 120.768,
    fill: "#ff5ba8",
    r: 10.901
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.424,
    cy: 120.768,
    fill: "#fff",
    r: 10.901
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.224,
    cy: 120.768,
    fill: "#02ffb3",
    r: 10.901
  })), /*#__PURE__*/React.createElement("path", {
    d: "m432.277 133.015h-136.158v-24.495h136.159c2.761 0 5 2.239 5 5v14.496c-.001 2.761-2.239 4.999-5.001 4.999z",
    fill: "#ffdbed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.789 108.831c-5.286-5.286-13.887-5.286-19.173 0s-5.286 13.887 0 19.173c4.037 4.037 10.003 4.98 14.953 2.852l4.348 4.348c1.952 1.952 5.119 1.952 7.071 0s1.952-5.119 0-7.071l-4.348-4.348c2.129-4.951 1.186-10.917-2.851-14.954zm-12.102 7.071c1.387-1.387 3.644-1.387 5.031 0s1.387 3.644 0 5.031-3.644 1.387-5.031 0-1.387-3.644 0-5.031z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m430.46 192.3v127.4c0 2.76-2.24 5-5 5h-338.92c-2.76 0-5-2.24-5-5v-127.4c0-2.76 2.24-5 5-5h338.92c2.76 0 5 2.24 5 5z",
    fill: "#01eca5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.46 236.07v83.63c0 2.76-2.24 5-5 5h-151.99c0-57.17 46.34-103.51 103.51-103.51 19.57 0 37.87 5.43 53.48 14.88z",
    fill: "#02ffb3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m361.959 272.386h-119.68c-2.761 0-5 2.239-5 5s2.239 5 5 5h119.681c2.761 0 5-2.239 5-5s-2.239-5-5.001-5z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m322.959 252.959h-80.681c-2.761 0-5 2.239-5 5s2.239 5 5 5h80.681c2.761 0 5-2.239 5-5s-2.238-5-5-5z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m253.959 229.614h-11.681c-2.761 0-5 2.239-5 5s2.239 5 5 5h11.681c2.761 0 5-2.239 5-5s-2.238-5-5-5z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m188.218 341.956h-101.681c-2.761 0-5 2.239-5 5s2.239 5 5 5h101.681c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
    fill: "#8399fe"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m371.977 358.762h-17.681c-2.761 0-5 2.239-5 5s2.239 5 5 5h17.681c2.761 0 5-2.239 5-5s-2.238-5-5-5z",
    fill: "#8399fe"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m425.463 358.762h-26.681c-2.761 0-5 2.239-5 5s2.239 5 5 5h26.681c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
    fill: "#8399fe"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m425.463 380.097h-71.166c-2.761 0-5 2.239-5 5s2.239 5 5 5h71.166c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
    fill: "#8399fe"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 157.525,
    cy: 254.46,
    fill: "#ff7eb8",
    r: 48.754
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.123 233.214v42.493c0 3.785 4.042 6.197 7.373 4.401l39.404-21.247c3.503-1.889 3.503-6.913 0-8.802l-39.404-21.247c-3.331-1.795-7.373.617-7.373 4.402z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m296.154 390.097h-209.617c-2.761 0-5-2.239-5-5v-15.335c0-2.761 2.239-5 5-5h209.617c2.761 0 5 2.239 5 5v15.335c0 2.761-2.239 5-5 5z",
    fill: "#ff7eb8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.154 364.762h-69.034v25.335h69.034c2.761 0 5-2.239 5-5v-15.335c0-2.761-2.239-5-5-5z",
    fill: "#01eca5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m108.771 485.004c-7.88 0-14.291-6.411-14.291-14.291 0-7.881 6.411-14.292 14.291-14.292s14.292 6.411 14.292 14.292c0 7.88-6.412 14.291-14.292 14.291zm0-18.583c-2.366 0-4.291 1.926-4.291 4.292s1.925 4.291 4.291 4.291 4.292-1.925 4.292-4.291-1.926-4.292-4.292-4.292z",
    fill: "#6583fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.527 50.579c-7.88 0-14.292-6.411-14.292-14.292 0-7.88 6.411-14.291 14.292-14.291s14.292 6.411 14.292 14.291c0 7.881-6.411 14.292-14.292 14.292zm0-18.583c-2.366 0-4.292 1.925-4.292 4.291s1.925 4.292 4.292 4.292 4.292-1.926 4.292-4.292-1.925-4.291-4.292-4.291z",
    fill: "#01eca5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m339.08 488.421c-2.761 0-5-2.238-5-5 0-3.309-2.691-6-6-6-2.761 0-5-2.238-5-5s2.239-5 5-5c3.309 0 6-2.691 6-6 0-2.762 2.239-5 5-5s5 2.238 5 5c0 3.309 2.691 6 6 6 2.761 0 5 2.238 5 5s-2.239 5-5 5c-3.309 0-6 2.691-6 6 0 2.762-2.239 5-5 5z",
    fill: "#ff5ba8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.745 477.421c-2.761 0-5-2.238-5-5 0-3.309-2.691-6-6-6-2.761 0-5-2.238-5-5s2.239-5 5-5c3.309 0 6-2.691 6-6 0-2.762 2.239-5 5-5s5 2.238 5 5c0 3.309 2.691 6 6 6 2.761 0 5 2.238 5 5s-2.239 5-5 5c-3.309 0-6 2.691-6 6 0 2.762-2.239 5-5 5z",
    fill: "#ff5ba8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.377 63.287c-2.761 0-5-2.238-5-5 0-3.309-2.691-6-6-6-2.761 0-5-2.238-5-5s2.239-5 5-5c3.309 0 6-2.691 6-6 0-2.762 2.239-5 5-5s5 2.238 5 5c0 3.309 2.691 6 6 6 2.761 0 5 2.238 5 5s-2.239 5-5 5c-3.309 0-6 2.691-6 6 0 2.762-2.238 5-5 5z",
    fill: "#6583fe"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService3);
export default __webpack_public_path__ + "static/media/service3.bd144b82783b8aa5b2431f1a5e3aac6c.svg";
export { ForwardRef as ReactComponent };